import { Link } from 'react-router-dom';

interface Props {
  hostname: string;
  ipAddress?: string | null;
  macAddress?: string | null;
  // Id dell'asset in Asset Inventory quando l'host risolve a una riga nota (join per hostname
  // lato backend, vedi routes/cases.ts / routes/alerts.ts): se presente, l'etichetta diventa un
  // link alla scheda asset. Un host "affected asset" comparso solo nei log (mai visto
  // dall'inventario, es. un IP esterno) resta testo semplice: non c'è una scheda da aprire.
  assetId?: number | null;
  // Nome dato all'apparato in Log Sources (log_sources.label, 26/10/2026): se presente viene
  // mostrato al posto dell'hostname, che resta accanto in grigio.
  label?: string | null;
}

// Mostra l'hostname con un tooltip al passaggio del mouse contenente IP/MAC dell'asset, quando
// noti (oggi popolati dalle estensioni CEF standard dvc/dvcmac in fase di ingestion), e — quando
// l'asset esiste in inventario — come link cliccabile verso la sua scheda.
export default function AssetHoverLabel({ hostname, ipAddress, macAddress, assetId, label: deviceLabel }: Props) {
  const name = deviceLabel ? <>{deviceLabel}<span className="text-gray-400"> · {hostname}</span></> : <>{hostname}</>;
  const label = !ipAddress && !macAddress ? (
    name
  ) : (
    <span className="group relative inline-block cursor-help border-b border-dotted border-gray-400">
      {name}
      <span className="pointer-events-none absolute left-1/2 z-30 mb-2 hidden -translate-x-1/2 -translate-y-full whitespace-nowrap rounded-lg bg-gray-900 px-3 py-2 text-xs text-white shadow-lg group-hover:block">
        {ipAddress && <div>IP: <span className="font-mono">{ipAddress}</span></div>}
        {macAddress && <div>MAC: <span className="font-mono">{macAddress}</span></div>}
        <span className="absolute left-1/2 top-full -translate-x-1/2 border-4 border-transparent border-t-gray-900" />
      </span>
    </span>
  );

  if (!assetId) return label;
  return (
    <Link to={`/asset-center/${assetId}`} className="text-primary-700 hover:underline">
      {label}
    </Link>
  );
}
